import React, {useMemo, useRef} from "react";
import {useQuery} from "@tanstack/react-query";
import {AgGridReact} from "ag-grid-react";
import {FaFileExcel} from "react-icons/fa";
import Modal from "../../../components/modal";
import Button from "../../../components/button";
import licensesService from "../../../services/licenses-service";
import {LocalizationAgGrid} from "../../../utils/localization-ag-grid";
import general from "../../../utils/general";
import DateGenerateCellRenderer from "./date-generate-cell-renderer";

const LicenseHistoryModal = ({isOpen, onClose, code}) => {
    const gridRef = useRef();

    const {data: licenses = [], isLoading, isError} = useQuery({
        queryFn: () => licensesService.get(code).then(({data}) => data?.licences ?? []),
        queryKey: ["license-history", {code}],
        enabled: isOpen && !!code,
    });

    const columnDefs = useMemo(() => [
        {field: "date_generate", headerName: "Emissão", cellRenderer: DateGenerateCellRenderer},
        {field: "modality", headerName: "Modalidade"},
        {field: "version", headerName: "Tipo"},
        {field: "lanes", headerName: "Câmeras", width: 100},
        {field: "user", headerName: "Usuários", width: 100},
        {field: "core", headerName: "OCR", width: 100},
        {field: "limitContactId", headerName: "Patrimonial", width: 110},
        {field: "limitDevices", headerName: "Mobile", width: 100},
        {field: "dateExpiration", headerName: "Expiração"},
        {field: "user_creation", headerName: "Criado por", flex: 1, minWidth: 250},
    ], []);

    const defaultColDef = useMemo(() => ({resizable: false}), []);

    const exportLicensing = () => {
        const exportData = licenses.map(license => ({
            "Emissão": license.date_generate,
            "Modalidade": license.modality,
            "Tipo": license.version,
            "Câmeras": license.lanes,
            "Usuários": license.user,
            "OCR": license.core,
            "Patrimonial": license.limitContactId,
            "Mobile": license.limitDevices,
            "Expiração": license.dateExpiration,
            "Criado por": license.user_creation,
        }));

        general.exportCsv(exportData);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Histórico de licenças"
            className="w-[95vw] max-w-[1400px]"
        >
            <div className="p-5">
                {isLoading && <p className="text-sm text-gray-500">Carregando histórico...</p>}
                {isError && <p className="text-sm text-red-600">Não foi possível carregar o histórico de licenças.</p>}
                {!isLoading && !isError && (
                    <>
                        {!!licenses.length && (
                            <div className="flex justify-end mb-2">
                                <Button target="success" onClick={exportLicensing} title="Exportar CSV">
                                    <FaFileExcel/>
                                </Button>
                            </div>
                        )}
                        <div className="ag-theme-quartz grid max-h-[70vh] overflow-auto">
                            <AgGridReact
                                ref={gridRef}
                                rowHeight={32}
                                rowData={licenses}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                animateRows={false}
                                suppressRowClickSelection={true}
                                suppressCellFocus={true}
                                gridOptions={{localeText: LocalizationAgGrid}}
                                domLayout="autoHeight"
                            />
                        </div>
                    </>
                )}
            </div>
        </Modal>
    );
};

export default LicenseHistoryModal;
